// test271
(271 && 0);
